import React from 'react';
import Grid from '@material-ui/core/Grid';

export default function CustomGridContainer({ children, ...props }) {
  return (
    <Grid container direction={props.direction || 'row'} alignItems={props.alignItems || 'center'} justifyContent={props.justify || 'center'} {...props}>
      {children}
    </Grid>
  );
}
